<ul class="breadcrumb">
  @if (!path().length) {
    <li class="breadcrumb__item">
      <span class="breadcrumb__item--empty">{{ 'FILE_BROWSER.SELECT_SOURCE' | translate }}</span>
    </li>
  } @else {
    @for (parentFolder of folders; track trackByName(i, parentFolder); let isLast = $last; let i = $index) {
      <li
        class="breadcrumb__item"
        [class.breadcrumb__item--extra]="parentFolder.id === 'extra'"
      >
        @if (parentFolder.id === 'extra') {
          <span class="breadcrumb__extra">...</span>
        } @else {
          <button
            class="breadcrumb__button"
            (click)="onFolderSelection(parentFolder)"
            [title]="parentFolder.name"
          >
            <span class="breadcrumb__button-text">{{ parentFolder.name }}</span>
          </button>
        }

        @if (!isLast) {
          <unis-icon
            class="breadcrumb__chevron"
            font="regular"
            icon="chevron-right"
          />
        }
      </li>
    }
  }

</ul>
